import { makeAutoObservable } from "mobx";

class TestStore {
  test = 'default'

  constructor(initialData: any) {
    makeAutoObservable(this)
    this.test = initialData?.test;
  }

  setTest(test:any) {
    this.test = test
  }

  // hydrate(data: any) {
  //   if(data.test){
  //     this.test.hydrate(data.test);
  //   }
  // }

  __data() {
    return {
      test: this.test,
    };
  }
}

export default TestStore;
